/* global ttq */
import React, { useCallback } from "react";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useAffiliate } from "../components/AffiliateContext";

const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = loadStripe(stripeKey);
const apiUrl = process.env.REACT_APP_API_BASE_URL;

const CheckoutForm = ({ cartItems }) => {
  const { affiliateId } = useAffiliate();
  console.log(cartItems);

  const fetchClientSecret = useCallback(() => {
    // if (window.ttq && cartItems.length) {
    //   ttq.track("InitiateCheckout", {
    //     contents: cartItems.map((item) => ({
    //       content_id: item.id,
    //       content_type: "product",
    //       content_name: `${item.id} (${item.size})`,
    //     })),
    //     currency: "GBP",
    //   });
    // }

    // Create a Checkout Session
    return fetch(`${apiUrl}/stripe/create-checkout-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-App-Secret": process.env.REACT_APP_APP_SECRET,
      },
      body: JSON.stringify({ cartItems, affiliateId }),
    })
      .then((res) => res.json())
      .then((data) => data.clientSecret);
  }, [cartItems]);

  const options = { fetchClientSecret };

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default CheckoutForm;
